/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Optout_LeadInputs */

const en_bot_optout_lead = /** @type {(inputs: Bot_Optout_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The fastest way is robots.txt. The rule applies to the next analysis, no need to contact us.`)
};

const id_bot_optout_lead = /** @type {(inputs: Bot_Optout_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cara tercepat adalah robots.txt. Aturan berlaku pada analisis berikutnya, tanpa perlu menghubungi kami.`)
};

/**
* | output |
* | --- |
* | "The fastest way is robots.txt. The rule applies to the next analysis, no need to contact us." |
*
* @param {Bot_Optout_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_optout_lead = /** @type {((inputs?: Bot_Optout_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Optout_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_optout_lead(inputs)
	return en_bot_optout_lead(inputs)
});